import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Header from "components/headers/light.js";
import Footer from "components/footers/MiniCenteredFooter.js";

const Refund = () => {
  return (
    <AnimationRevealPage>
      <Header />
      <div className=" min-h-screen w-[90%] m-auto py-16">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Refund Policy</h1>

        <p className="text-gray-700 mb-4">
          Our policy lasts 5 to 7 business days. If 7 days have gone by since your purchase,
          unfortunately we can’t offer you a refund or exchange. <br /> <br />{" "}
          To be eligible for a return, your item must be unused and in the same
          condition that you received it. It must also be in the original
          packaging. <br /> <br /> Several types of goods are exempt from being
          returned. Perishable goods such as food, flowers, newspapers or
          magazines cannot be returned. We also do not accept products that are
          intimate or sanitary goods, hazardous materials, or flammable liquids
          or gases. <br /> <br /> Additional non-returnable items: Gift cards
          Downloadable software products Some health and personal care items{" "}
          <br /> <br /> To complete your return, we require a receipt or proof
          of purchase. <br /> <br /> Please do not send your purchase back to
          the manufacturer. <br /> <br /> There are certain situations where
          only partial refunds are granted: (if applicable) Book with obvious
          signs of use <br /> CD, DVD, VHS tape, software, video game, cassette
          tape, or vinyl record that has been opened.
          <br /> Any item not in its original condition, is damaged or missing
          parts for reasons not due to our error. <br /> Any item that is
          returned more than 30 days after delivery
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6">
          Refunds (if applicable)
        </h2>
        <p className="text-gray-700 mt-2">
          Once your return is received and inspected, we will send you an email
          to notify you that we have received your returned item. We will also
          notify you of the approval or rejection of your refund. If you are
          approved, then your refund will be processed, and a credit will
          automatically be applied to your credit card or original method of
          payment, within a certain amount of days.
        </p>
        <ul className="list-disc list-inside text-gray-700 mt-2">
          <li>
            The item must be unused and in the same condition as received.
          </li>
          <li>It must be in the original packaging.</li>
          <li>A receipt or proof of purchase is required.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6">
          Late or missing refunds (if applicable)
        </h2>
        <p className="text-gray-700 mt-2">
          If you haven’t received a refund yet, first check your bank account
          again. Then contact your credit card company, it may take some time
          before your refund is officially posted. <br /> Next contact your
          bank. There is often some processing time before a refund is posted.{" "}
          <br /> <br /> If you’ve done all of this and you still have not
          received your refund yet, please contact us at
          <strong>helpyourselfgoals@gmail.com</strong>
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6">
          Sale items (if applicable)
        </h2>
        <p className="text-gray-700 mt-2">
          Only regular priced items may be refunded, unfortunately sale items
          cannot be refunded.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6">
          Exchanges (if applicable)
        </h2>
        <p className="text-gray-700 mt-2">
          We only replace items if they are defective or damaged. If you need to
          exchange it for the same item, send us an email at{" "}
          <strong>helpyourselfgoals@gmail.com</strong> and send your item to:
          nanal Nagar khader bagh Premier Hospital Hyderabad Telangana 500008.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6">Gifts</h2>
        <p className="text-gray-700 mt-6">
          If the item was marked as a gift when purchased and shipped directly
          to you, you’ll receive a gift credit for the value of your return.
          Once the returned item is received, a gift certificate will be mailed
          to you.
          <br /> <br />
          If the item wasn’t marked as a gift when purchased, or the gift giver
          had the order shipped to themselves to give to you later, we will send
          a refund to the gift giver and he will find out about your return.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6">Shipping</h2>
        <p className="text-gray-700 mt-6">
          To return your product, you should mail your product to: nanal Nagar
          khader bagh Premier Hospital Hyderabad Telangana 500008 <br /> <br />
          You will be responsible for paying for your own shipping costs for
          returning your item. Shipping costs are non-refundable. If you receive
          a refund, the cost of return shipping will be deducted from your
          refund. <br /> <br />
          Depending on where you live, the time it may take for your exchanged
          product to reach you, may vary.
        </p>
      </div>
      <Footer />
    </AnimationRevealPage>
  );
};

export default Refund;
